import React, { useState } from 'react'
import EditableProjectTable from './EditableProjectTable'
import TokenTimelineTab from './TokenTimelineTab'
import { Project } from '../services/api'

interface TabbedDashboardProps {
  projects: Project[]
  onUpdateProject: (project: Project) => void
  onAddProject: (project: Project) => void
  onDeleteProject: (projectId: number) => void
}

const TabbedDashboard: React.FC<TabbedDashboardProps> = ({
  projects,
  onUpdateProject,
  onAddProject,
  onDeleteProject
}) => {
  const [activeTab, setActiveTab] = useState<'projects' | 'timeline'>('projects')

  return (
    <div className="space-y-6">
      {/* Tab Navigation */}
      <div className="flex space-x-1 bg-white/5 backdrop-blur-sm rounded-lg p-1">
        <button
          onClick={() => setActiveTab('projects')}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === 'projects'
              ? 'bg-blue-500 text-white'
              : 'text-gray-300 hover:text-white hover:bg-white/10'
          }`}
        >
          Projects
        </button>
        <button
          onClick={() => setActiveTab('timeline')}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === 'timeline'
              ? 'bg-blue-500 text-white'
              : 'text-gray-300 hover:text-white hover:bg-white/10'
          }`}
        >
          Token Timeline
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'projects' && (
        <EditableProjectTable
          projects={projects}
          onUpdateProject={onUpdateProject}
          onAddProject={onAddProject}
          onDeleteProject={onDeleteProject}
        />
      )}
      
      {activeTab === 'timeline' && (
        <TokenTimelineTab projects={projects} />
      )}
    </div>
  )
}

export default TabbedDashboard 